import React from 'react';

import { GenericTag } from './GenericTag';

export const SimuliveStatusTag = ({
  value,
  label,
}: {
  value: 'simulive' | 'live';
  label: string;
}) => (
  <GenericTag
    testId={`simulive-status-${value}`}
    styling={{
      backgroundColor:
        value === 'simulive' ? 'COLOR.GREEN.100' : 'COLOR.YELLOW.100',
      textColor: value === 'simulive' ? 'COLOR.GREEN.500' : 'COLOR.YELLOW.500',
      px: 1,
    }}
    label={label}
  />
);
